export type Nullable<T> = T | null | undefined;

export const isDefined = <T>(value?: Nullable<T>): value is T => {
  return value !== null && value !== undefined;
};

export const isNullable = <T>(value?: Nullable<T>): value is null | undefined => !isDefined(value);

export const hasValue = <T>(value?: Nullable<T>): value is T => {
  // If its null or undefined, it doesnt have a value
  if (isNullable(value)) {
    return false;
  }
  // If its a number and not null or undefined, it has a value
  if (typeof value === "number") {
    return true;
  }
  // For "string", ["array"] and { object: 123 } this return the length
  return Object.keys(value as any).length > 0;
};

export const isEmpty = <T>(value?: Nullable<T>): value is null | undefined => !hasValue(value);
